import { render } from "./ProductVp.vue?vue&type=template&id=3b85f334"
import script from "./ProductVp.vue?vue&type=script&lang=js"
export * from "./ProductVp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__